import httpService from './httpService';
import { IPinWidgetData } from './types/IPinWidgetData';
import { IHomePage } from './types/IHomePage';
import { AnalysisContentModel } from '../../models/AnalysisContentModel';
import { IMediaContent } from './types/IMediaContent';
import { IHome } from '../boards/types/IHome';

export const getHomePage = (): Promise<IHome> => {
  let endpoint = httpService.getEndpointURL(`/Home`);
  return httpService.getTyped<IHome>(endpoint);
};

export const getMediaContent = (): Promise<IMediaContent[]> => {
  let endpoint = httpService.getEndpointURL(`/Media`);
  return httpService.getTyped<IMediaContent[]>(endpoint);
}

export const getHomePageBoards = (): Promise<any[]> => {
  let endpoint = httpService.getEndpointURL('/Home/boardContent');
  return httpService.get(endpoint).then((res) => {
    let boards = [];
    res.data.forEach((board) => {
      boards.push(board);
    });
    return boards;
  });
};

export const pinWidget = (investorId: number, boardId: number, data: IPinWidgetData): Promise<any> => {
  let endpoint = httpService.getEndpointURL(`/Home/pin/${investorId}/content/${boardId}`);
  return httpService.post(endpoint, data).then((res) => res.data);
};

export const updatePinnedWidgets = (widgets): Promise<any> => {
  const data = widgets.map((widget) => {
    return {
      id: widget.unpinId,
      pageId: 0,
      contentType: 'analysisContent',
      widgetId: widget.widget.id,
      scenarioSectionId: 0,
      objectId: widget.selectedObject.objectId,
      objectPath: widget.selectedObject.objectPath,
      investorObjectId: widget.investorObjectId,
      setup: null,
      nodes: widget.widget.nodes,
    };
  });
  let endpoint = httpService.getEndpointURL(`/Home/pinnedContent`);
  return httpService.put(endpoint, data);
};

export const unpinWidget = (pinContentId: number): Promise<any> => {
  let endpoint = httpService.getEndpointURL(`/Home/unpin/${pinContentId}`);
  return httpService.delete(endpoint).then((res) => res.data);
};

export const unpinWidgetFromBoard = (investorObjectId: number, widgetId: number, objectPath: string): Promise<any> => {
  let endpoint = httpService.getEndpointURL(`/Home/unpin/${investorObjectId}/${widgetId}/${objectPath}`);
  return httpService.delete(endpoint).then((res) => res.data);
};